import type { BetId } from './types.js';

let counter = 0;

export function newBetId(): BetId {
  counter += 1;
  return `bet-${Date.now()}-${counter}` as BetId;
}

export class BetIdGenerator {
  private n = 0;
  next(): BetId {
    this.n += 1;
    return `bet-${this.n}` as BetId;
  }
  /** Advance the counter past any previously-issued IDs (used post-hydrate). */
  seedAtLeast(n: number): void {
    if (n > this.n) this.n = n;
  }
  /** Current counter value (highest id issued; 0 = none yet). For serialize(). */
  current(): number { return this.n; }
}
